import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

const Name = styled.div`
  white-space: pre;
  display: inline-block;
  margin: 0px var(--hs) var(--lh) var(--hs);
  color: var(--bold-color);
  text-shadow: 0px 0px 5px var(--bold-color);
`

const michael = ` _____ _     _           _
|     |_|___| |_ ___ ___| |
| | | | |  _|   | .'| -_| |
|_|_|_|_|___|_|_|__,|___|_|
`

const pearson = ` _____
|  _  |___ ___ ___ ___ ___ ___
|   __| -_| .'|  _|_ -| . |   |
|__|  |___|__,|_| |___|___|_|_|
`

const TopP = styled.p`
  margin-bottom: 2px;
`

const PostLink = ({ post }) => (
  <p>
    <Link to={post.frontmatter.path}>{post.frontmatter.title}</Link>
    <br />
    {post.frontmatter.date}
  </p>
)

const IndexPage = ({
  data: {
    allMarkdownRemark: { edges },
  },
}) => {
  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.published)
    .map(edge => <PostLink key={edge.node.id} post={edge.node} />)

  return (
    <div>
      <TopP>Hi, I'm</TopP>
      <Name aria-label="Michael">{michael}</Name>
      <Name aria-label="Pearson">{pearson}</Name>
      <p>and this is my website.</p>
      <p>
        I'm a software developer, systems administrator and manager with a focus
        on team process improvement, systems automation, and pragmatic
        architecture. I live in the{' '}
        <a
          href="https://www.instagram.com/p/BF2pp7rzWLF/?taken-by=mipearson"
          target="_blank"
        >
          Dandenong Ranges in Victoria
        </a>{' '}
        with{' '}
        <a
          href="https://www.instagram.com/p/Bh2ixp1nOTP/?taken-by=mipearson"
          target="_blank"
        >
          one dog
        </a>,{' '}
        <a
          href="https://www.instagram.com/p/BZp2IfsH3Gd/?taken-by=mipearson"
          target="_blank"
        >
          two cats
        </a>, and{' '}
        <a href="https://twitter.com/kate_biscuit" target="_blank">
          one Marine Biologist
        </a>.
      </p>
      <h2>Recent Writing</h2>
      {Posts}
      <h2>Games</h2>
      <p>
        <a href="https://mipearson.itch.io/breakout">Breakout</a>:
        teach-myself-Unity project, replicating a Breakout game
      </p>
      <h2>Elsewhere</h2>
      <p>
        <a href="https://twitter.com/mipearson">Twitter</a>{' '}
        <a href="https://medium.com/@mipearson">Medium</a>{' '}
        <a href="https://www.instagram.com/mipearson/">Instagram</a>{' '}
        <a href="https://github.com/mipearson">Github</a>
      </p>
    </div>
  )
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "DD MMM YYYY")
            path
            title
            published
          }
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js